export class DeviceToken {
  deviceTokenId: number;
  naam: string;
  passkey: string;
  tokenStatus: string;
  geldig: boolean;
}
